export default __webpack_public_path__ + "static/media/under_midashi_sp.1a482dee.jpg";